import { createSignal } from 'solid-js';
import ModalBase from '../modals/ModalBase';
import type { StreamerData } from '../../../mocks/streamers/schema';

interface Props {
  open: boolean;
  streamer: StreamerData;
  onJoin: () => void;
  onSkip: (dontShowAgain: boolean) => void;
}

export default function JoinModal(props: Props) {
  const [dontShowAgain, setDontShowAgain] = createSignal(false);

  const onJoinClick = () => props.onJoin();
  const onSkipClick = () => props.onSkip(dontShowAgain());

  return (
    <ModalBase id="streamer-join" title="Join Streamer Room" open={props.open} onClose={() => onSkipClick()} size="sm">
      <div class="streamer-join">
        <div class="streamer-join-head">
          <div class="streamer-avatar-wrap streamer-avatar-lg">
            <img src={props.streamer.avatar} alt={`${props.streamer.displayName} avatar`} />
          </div>
          <div class="streamer-join-meta">
            <div class="streamer-join-name">{props.streamer.displayName}</div>
            <div class="streamer-join-slogan">{props.streamer.slogan || 'Jump into the live room and mirror the vibe.'}</div>
          </div>
        </div>

        <label class="streamer-join-checkbox">
          <input
            type="checkbox"
            checked={dontShowAgain()}
            onInput={(e: InputEvent & { currentTarget: HTMLInputElement }) => setDontShowAgain(e.currentTarget.checked)}
          />
          <span class="streamer-join-checkmark" aria-hidden="true"></span>
          <span>Don't show again</span>
        </label>

        <div class="streamer-join-actions">
          <button class="streamer-btn streamer-btn-secondary" type="button" onClick={onSkipClick}>
            Skip
          </button>
          <button class="streamer-btn streamer-btn-primary" type="button" onClick={onJoinClick} data-autofocus>
            Join
          </button>
        </div>
      </div>
    </ModalBase>
  );
}
